import axios from "axios";
import { EnvironmentConfig } from "@me8eon/config";
import { JwtTokenFn } from "@me8eon/authentication";

const ELASTICSEARCH_URL = `${EnvironmentConfig.elasticSearchProxyUrl.replace(/\/$/, "")}/${EnvironmentConfig.serviceNowRoutesIndex}/_search`;

export async function getAssignmentGroupFromElasticsearch(description: string, jwtTokenFn: JwtTokenFn): Promise<string | null> {
  const token = await jwtTokenFn();
  const minHybridScore = 0.5;

  if (!token) {
    console.warn("Authentication token is not set. Falling back to default assignment group.");
    return null;
  }

  // Hybrid search: BM25 on short_description + kNN on full_text_embeddings
  // Elasticsearch will automatically combine scores from both query and knn
  // const query = {
  //   size: 1,
  //   min_score: minHybridScore,
  //   _source: {
  //     excludes: ["full_text_embeddings"]  // Don't return embeddings in response
  //   },
  //   query: {
  //     match: {
  //       short_description: {
  //         query: description,
  //         boost: 2 // boost the text matching untill documents in index > 1
  //       }
  //     }
  //   },
  //   knn: {
  //     field: "full_text_embeddings",
  //     query_vector_builder: {
  //       text_embedding: {
  //         model_id: ".multilingual-e5-small_linux-x86_64",
  //         model_text: description
  //       }
  //     },
  //     k: 1,  // adapt to a json with 1 document
  //     num_candidates: 1,  // adapt to a json with 1 document
  //     similarity: 0.75
  //   }
  // };

  const query = {
  size: 1,
  min_score: 0.5,
  query: {
    match: {
      u_routing_instruction: {
        query: description,
        minimum_should_match: "30%"
      }}}};

  try {
    const response = await axios.post(
      ELASTICSEARCH_URL,
      query,
      {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      }
    );
    const hits = response.data.hits?.hits;

    if (hits && hits.length > 0) {
      const topHit = hits[0];
      const topScore = typeof topHit._score === "number" ? topHit._score : 0;

      if (topScore < minHybridScore) {
        return null;
      }

      return topHit._source.u_assignment_group || null;
    }
    return null;
  } catch (error: any) {
    console.error("Elasticsearch search error:", error);
    if (error.response) {
      console.error("Elasticsearch error details:", JSON.stringify(error.response.data, null, 2));
    }
    return null;
  }
}
